import React from 'react';
import SvgIcon from './SvgIcon';

/**
 * @param {FF.SvgIcon} props
 */
function PhoneWithPickupPINIcon(props) {
  return (
    <SvgIcon width="80" height="80" viewBox="0 0 80 80" fill="none" {...props}>
      <title>Phone with Pick Up PIN</title>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27.7951 8.53333H52.4147C55.9318 8.53333 58.6952 11.434 58.6952 14.8392V65.0346C58.6952 68.5659 55.9318 71.4667 52.4147 71.4667H27.7951C24.4037 71.4667 21.5146 68.5659 21.5146 65.0346V14.8392C21.5146 11.434 24.4037 8.53333 27.7951 8.53333Z"
        fill="#74AA50"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M35.4802 13.8178H44.7811C45.2839 13.8178 45.5352 13.4247 45.5352 13.0317C45.5352 12.6386 45.2839 12.3766 44.7811 12.3766H35.4802C35.1031 12.3766 34.7261 12.6386 34.7261 13.0317C34.7261 13.4247 35.1031 13.8178 35.4802 13.8178Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M40.1307 65.2214C39.2199 65.2214 38.5693 65.9708 38.5693 66.8452C38.5693 67.5946 39.2199 68.344 40.1307 68.344C41.0414 68.344 41.692 67.5946 41.692 66.8452C41.692 65.9708 41.0414 65.2214 40.1307 65.2214Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.6372 62.3389H55.6235V17.6611H24.6372V62.3389Z"
        fill="white"
      />
      <path
        d="M47.7335 50.3111C47.0247 50.3111 46.4178 50.0587 45.913 49.5539C45.4082 49.0491 45.1558 48.4422 45.1558 47.7334C45.1558 47.0245 45.4082 46.4176 45.913 45.9128C46.4178 45.408 47.0247 45.1556 47.7335 45.1556C48.4424 45.1556 49.0493 45.408 49.5541 45.9128C50.0589 46.4176 50.3113 47.0245 50.3113 47.7334C50.3113 48.4422 50.0589 49.0491 49.5541 49.5539C49.0493 50.0587 48.4424 50.3111 47.7335 50.3111Z"
        fill="#D3EBC2"
      />
      <path
        d="M38.1796 49.5539C38.6844 50.0587 39.2913 50.3111 40.0001 50.3111C40.709 50.3111 41.3159 50.0587 41.8207 49.5539C42.3255 49.0491 42.5779 48.4422 42.5779 47.7334C42.5779 47.0245 42.3255 46.4176 41.8207 45.9128C41.3159 45.408 40.709 45.1556 40.0001 45.1556C39.2913 45.1556 38.6844 45.408 38.1796 45.9128C37.6748 46.4176 37.4224 47.0245 37.4224 47.7334C37.4224 48.4422 37.6748 49.0491 38.1796 49.5539Z"
        fill="#368007"
      />
      <path
        d="M30.4462 49.5539C30.951 50.0587 31.5579 50.3111 32.2667 50.3111C32.9756 50.3111 33.5825 50.0587 34.0873 49.5539C34.5921 49.0491 34.8445 48.4422 34.8445 47.7334C34.8445 47.0245 34.5921 46.4176 34.0873 45.9128C33.5825 45.408 32.9756 45.1556 32.2667 45.1556C31.5579 45.1556 30.951 45.408 30.4462 45.9128C29.9414 46.4176 29.689 47.0245 29.689 47.7334C29.689 48.4422 29.9414 49.0491 30.4462 49.5539Z"
        fill="#1B6100"
      />
      <path
        d="M30.4462 41.8206C30.951 42.3254 31.5579 42.5778 32.2667 42.5778C32.9756 42.5778 33.5825 42.3254 34.0873 41.8206C34.5921 41.3158 34.8445 40.7089 34.8445 40C34.8445 39.2911 34.5921 38.6843 34.0873 38.1795C33.5825 37.6746 32.9756 37.4222 32.2667 37.4222C31.5579 37.4222 30.951 37.6746 30.4462 38.1795C29.9414 38.6843 29.689 39.2911 29.689 40C29.689 40.7089 29.9414 41.3158 30.4462 41.8206Z"
        fill="#368007"
      />
      <path
        d="M45.913 41.8206C46.4178 42.3254 47.0247 42.5778 47.7335 42.5778C48.4424 42.5778 49.0493 42.3254 49.5541 41.8206C50.0589 41.3158 50.3113 40.7089 50.3113 40C50.3113 39.2911 50.0589 38.6843 49.5541 38.1795C49.0493 37.6746 48.4424 37.4222 47.7335 37.4222C47.0247 37.4222 46.4178 37.6746 45.913 38.1795C45.4082 38.6843 45.1558 39.2911 45.1558 40C45.1558 40.7089 45.4082 41.3158 45.913 41.8206Z"
        fill="#1B6100"
      />
      <path
        d="M45.913 41.8206C46.4178 42.3254 47.0247 42.5778 47.7335 42.5778C48.4424 42.5778 49.0493 42.3254 49.5541 41.8206C50.0589 41.3158 50.3113 40.7089 50.3113 40C50.3113 39.2911 50.0589 38.6843 49.5541 38.1795C49.0493 37.6746 48.4424 37.4222 47.7335 37.4222C47.0247 37.4222 46.4178 37.6746 45.913 38.1795C45.4082 38.6843 45.1558 39.2911 45.1558 40C45.1558 40.7089 45.4082 41.3158 45.913 41.8206Z"
        fill="#1B6100"
      />
      <path
        d="M38.0907 41.8206C38.5955 42.3254 39.2024 42.5778 39.9113 42.5778C40.6202 42.5778 41.227 42.3254 41.7318 41.8206C42.2366 41.3158 42.4891 40.7089 42.4891 40C42.4891 39.2911 42.2366 38.6843 41.7318 38.1795C41.227 37.6746 40.6202 37.4222 39.9113 37.4222C39.2024 37.4222 38.5955 37.6746 38.0907 38.1795C37.5859 38.6843 37.3335 39.2911 37.3335 40C37.3335 40.7089 37.5859 41.3158 38.0907 41.8206Z"
        fill="#D3EBC2"
      />
      <path
        d="M45.913 34.0872C46.4178 34.5921 47.0247 34.8445 47.7335 34.8445C48.4424 34.8445 49.0493 34.5921 49.5541 34.0872C50.0589 33.5824 50.3113 32.9756 50.3113 32.2667C50.3113 31.5578 50.0589 30.9509 49.5541 30.4461C49.0493 29.9413 48.4424 29.6889 47.7335 29.6889C47.0247 29.6889 46.4178 29.9413 45.913 30.4461C45.4082 30.9509 45.1558 31.5578 45.1558 32.2667C45.1558 32.9756 45.4082 33.5824 45.913 34.0872Z"
        fill="#368007"
      />
      <path
        d="M38.1796 34.0872C38.6844 34.5921 39.2913 34.8445 40.0001 34.8445C40.709 34.8445 41.3159 34.5921 41.8207 34.0872C42.3255 33.5824 42.5779 32.9756 42.5779 32.2667C42.5779 31.5578 42.3255 30.9509 41.8207 30.4461C41.3159 29.9413 40.709 29.6889 40.0001 29.6889C39.2913 29.6889 38.6844 29.9413 38.1796 30.4461C37.6748 30.9509 37.4224 31.5578 37.4224 32.2667C37.4224 32.9756 37.6748 33.5824 38.1796 34.0872Z"
        fill="#1B6100"
      />
      <path
        d="M30.4462 34.0872C30.951 34.5921 31.5579 34.8445 32.2667 34.8445C32.9756 34.8445 33.5825 34.5921 34.0873 34.0872C34.5921 33.5824 34.8445 32.9756 34.8445 32.2667C34.8445 31.5578 34.5921 30.9509 34.0873 30.4461C33.5825 29.9413 32.9756 29.6889 32.2667 29.6889C31.5579 29.6889 30.951 29.9413 30.4462 30.4461C29.9414 30.9509 29.689 31.5578 29.689 32.2667C29.689 32.9756 29.9414 33.5824 30.4462 34.0872Z"
        fill="#D3EBC2"
      />
    </SvgIcon>
  );
}

export default PhoneWithPickupPINIcon;
